// import mulixVisa from './mulix-visa'

import ARPage from './AR.vue'

import BRData from './BR.json'
import BRPage from './BR.vue'

import CLData from './CL.json'
import CLPage from './CL.vue'

import COData from './CO.json'
import COPage from './CO.vue'

import CRPage from './CR.vue'

import ECData from './EC.json'
import ECPage from './EC.vue'

import MXData from './MX.json'
import MXPage from './MX.vue'

import PEData from './PE.json'
import PEPage from './PE.vue'

export default {
  // mulixVisa,
  AR: {
    page: ARPage,
  },
  BR: {
    data: BRData,
    page: BRPage,
  },
  CL: { data: CLData, page: CLPage },
  CO: { data: COData, page: COPage },
  CR: { page: CRPage },
  EC: { data: ECData, page: ECPage },
  MX: { data: MXData, page: MXPage },
  PE: { data: PEData, page: PEPage },
}



// WEBPACK FOOTER //
// ./src/views/finance/withdraw-methods/mulix-wd-methods/payretailers-options/index.js